export const level = {
    moves: 25,
    field: [
    [
        "-",
        "+",
        "+",
        "+",
        "+",
        "+",
        "+",
        "+",
        "+",
        "-"
    ],
    [
        "+",
        "+",
        "+",
        "+",
        "+",
        "+",
        "+",
        "+",
        "+",
        "+"
    ],
    [
        "+",
        "+",
        "+",
        "+",
        "+",
        "+",
        "+",
        "+",
        "+",
        "+"
    ],
    [
        "+",
        "+",
        "+",
        "+",
        "+",
        "+",
        "+",
        "+",
        "+",
        "+"
    ],
    [
        "+",
        "+",
        "+",
        "+",
        "+",
        "+",
        "+",
        "+",
        "+",
        "+"
    ],
    [
        "+",
        "+",
        "+",
        "+",
        "+",
        "+",
        "+",
        "+",
        "+",
        "+"
    ],
    [
        "+",
        "+",
        "+",
        "+",
        "+",
        "+",
        "+",
        "+",
        "+",
        "+"
    ],
    [
        "+",
        "+",
        "+",
        "+",
        "+",
        "+",
        "+",
        "+",
        "+",
        "+"
    ],
    [
        "+",
        "+",
        "+",
        "+",
        "+",
        "+",
        "+",
        "+",
        "+",
        "+"
    ],
    [
        "-",
        "+",
        "+",
        "+",
        "+",
        "+",
        "+",
        "+",
        "+",
        "-"
    ]
],
objects: [
    {
        "position": {
            "x": 5,
            "y": 7
        },
        "type": 5
    },
    {
        "position": {
            "x": 4,
            "y": 7
        },
        "type": 5
    },
    {
        "position": {
            "x": 3,
            "y": 8
        },
        "type": 5
    },
    {
        "position": {
            "x": 4,
            "y": 8
        },
        "type": 5
    },
    {
        "position": {
            "x": 5,
            "y": 8
        },
        "type": 5
    },
    {
        "position": {
            "x": 6,
            "y": 8
        },
        "type": 5
    },
    {
        "position": {
            "x": 7,
            "y": 9
        },
        "type": 5
    },
    {
        "position": {
            "x": 6,
            "y": 9
        },
        "type": 5
    },
    {
        "position": {
            "x": 5,
            "y": 9
        },
        "type": 5
    },
    {
        "position": {
            "x": 4,
            "y": 9
        },
        "type": 5
    },
    {
        "position": {
            "x": 3,
            "y": 9
        },
        "type": 5
    },
    {
        "position": {
            "x": 2,
            "y": 9
        },
        "type": 5
    },
    {
        "position": {
            "x": 8,
            "y": 4
        },
        "type": 10
    },
    {
        "position": {
            "x": 7,
            "y": 4
        },
        "type": 10
    },
    {
        "position": {
            "x": 6,
            "y": 4
        },
        "type": 10
    },
    {
        "position": {
            "x": 5,
            "y": 4
        },
        "type": 10
    },
    {
        "position": {
            "x": 4,
            "y": 4
        },
        "type": 10
    },
    {
        "position": {
            "x": 3,
            "y": 4
        },
        "type": 10
    },
    {
        "position": {
            "x": 2,
            "y": 4
        },
        "type": 10
    },
    {
        "position": {
            "x": 1,
            "y": 4
        },
        "type": 10
    },
    {
        "position": {
            "x": 0,
            "y": 4
        },
        "type": 10
    },
    {
        "position": {
            "x": 0,
            "y": 5
        },
        "type": 10
    },
    {
        "position": {
            "x": 1,
            "y": 5
        },
        "type": 10
    },
    {
        "position": {
            "x": 2,
            "y": 5
        },
        "type": 10
    },
    {
        "position": {
            "x": 3,
            "y": 5
        },
        "type": 10
    },
    {
        "position": {
            "x": 4,
            "y": 5
        },
        "type": 10
    },
    {
        "position": {
            "x": 5,
            "y": 5
        },
        "type": 10
    },
    {
        "position": {
            "x": 6,
            "y": 5
        },
        "type": 10
    },
    {
        "position": {
            "x": 7,
            "y": 5
        },
        "type": 10
    },
    {
        "position": {
            "x": 8,
            "y": 5
        },
        "type": 10
    },
    {
        "position": {
            "x": 9,
            "y": 5
        },
        "type": 10
    },
    {
        "position": {
            "x": 9,
            "y": 4
        },
        "type": 10
    },
    {
        "position": {
            "x": 9,
            "y": 3
        },
        "type": 10
    },
    {
        "position": {
            "x": 8,
            "y": 3
        },
        "type": 10
    },
    {
        "position": {
            "x": 7,
            "y": 3
        },
        "type": 10
    },
    {
        "position": {
            "x": 6,
            "y": 3
        },
        "type": 10
    },
    {
        "position": {
            "x": 5,
            "y": 3
        },
        "type": 10
    },
    {
        "position": {
            "x": 4,
            "y": 3
        },
        "type": 10
    },
    {
        "position": {
            "x": 3,
            "y": 3
        },
        "type": 10
    },
    {
        "position": {
            "x": 2,
            "y": 3
        },
        "type": 10
    },
    {
        "position": {
            "x": 1,
            "y": 3
        },
        "type": 10
    },
    {
        "position": {
            "x": 0,
            "y": 3
        },
        "type": 10
    }
]
}